<template>
  <div>
    <facit-header></facit-header>
      <div class = "profile-div col-12">
        <h5 class="mt-3 mb-3"> User Management </h5>
        <b-row class="float-right">
          <b-col class="my-1">
            <b-form-group horizontal label="" class="mb-3">
              <b-input-group>
                <b-form-input v-model="filter" placeholder="Search" />
                <b-btn class="clearBtn" :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-table  striped hover
                  show-empty
                  empty-text="There are no users to show"
                  :fields="userList"
                  :items="users"
                  :filter="filter"
                  :current-page="currentPage"
                  :per-page="perPage">
          <template slot="link" slot-scope="data">
            <i @click="getHistory(data.item.id)" title="License Detail">
              <v-icon name="info" base-class="icon-width" @click="getHistory(data.item.id)">
              </v-icon>
            </i>
          </template>
          <template slot="emailVerified" slot-scope="data">
            <label class="switch">
            <input type="checkbox"
                   v-model="data.value"
                   @change="statusUpdate(data.item.id,data.value)">
            <span class="slider round"></span>
          </label>
          </template>
        </b-table>
        <br>
        <b-pagination align="right"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      v-model="currentPage"
                      class="my-0" />
      </div>
  </div>
</template>

<script>
import API from '@/api';
import FacitHeader from '@/components/header';
import moment from 'moment';

export default {
  name: 'userManagement',
  components: { FacitHeader },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      users: null,
      history: null,
      userSettingsModal: false,
      trialLimit: null,
      amount: null,
      credits: null,
      options: null,
      userId: null,
      accountType: 0,
      purchased: false,
      filter: null,
      devices: null,
      moment: moment,
      userList: [
        {
          key: 'firstname',
          label: 'First Name',
          sortable: true,
        },
        {
          key: 'lastname',
          label: 'Last Name',
          sortable: true,
        },
        {
          key: 'email',
          label: 'Email Address',
          sortable: true,
        },
        {
          key: 'companyname',
          label: 'Company Name',
          sortable: true,
        },
        {
          key: 'country',
          label: 'Country',
          sortable: false,
        },
        {
          key: 'created',
          label: 'Created',
          sortable: true,
          formatter: (value) => {
            return moment.utc(value).format('DD-MM-YYYY HH:mm');
          },
        },
        {
          key: 'emailVerified',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'link',
          label: 'Action',
          sortable: false,
        },
      ],
    };
  },
  async created() {
    this.getUsers();
  },
  methods: {
    async getUsers() {
      this.users = await API.get('Accounts?filter={"order": "created DESC"}');
      this.totalRows = this.users.length;
    },
    async statusUpdate(userId, currentStatus) {
      try {
        await API.patch(`Accounts/${userId}`, {
          emailVerified: currentStatus,
        });
      } catch (error) {
          await this.$notify({
            group: 'sitewide',
            title: 'Error!',
            type: 'error',
            text: 'Unable to update status',
          });
          this.getUsers();
      }
    },
    async getHistory(userId) {
      this.$router.push(`/admin/userHistory?id=${userId}`);
    },
    async getLoginHistory(userId) {
      this.$router.push(`/admin/loginHistory?id=${userId}`);
    },
    async getDetail(userId) {
      const accountDetail = await API.get(`Accounts/${userId}`);
      this.trialLimit = accountDetail.trialLimit;
      this.devices = accountDetail.totalDevices;
      this.amount = accountDetail.packageId;
      this.credits = accountDetail.credits;
      this.userId = userId;
      this.userSettingsModal = true;
    },
    async updateProfile(scope) {
      try {
        const validation = await this.$validator.validateAll(scope);
        if (validation) {
          const clientId = this.userId;
          await API.patch(`Accounts/${clientId}`, {
            packageId: this.amount,
            credits: this.credits,
            trialLimit: this.trialLimit,
            accountType: this.accountType,
            purchased: this.purchased,
            totalDevices: this.devices,
          });
          this.userId = null;
          this.userSettingsModal = false;
          this.$notify({
            group: 'sitewide',
            title: 'Success!',
            type: 'success',
            text: 'Updated Sucessfully',
          });
        }
      } catch (error) {
        this.userId = null;
        this.userSettingsModal = false;
        this.$notify({
          group: 'sitewide',
          title: 'Error!',
          type: 'error',
          text: 'Error while update',
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-warning {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
}
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
.page-item.active .page-link {
  z-index: 1;
    color: #fff;
    background-color: #6610f2 !important;
    border-color: #6610f2 !important;
}
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}
.clearBtn {
  color: #fff;
  background-color: #ff8f00;
  border-color: #ff8f00;
  margin-left: 10px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #d6700a;
}

input:focus + .slider {
  box-shadow: 0 0 1px #d6700a;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 20px;
}
.switch input {
  display:none;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/users.vue